import { CONFIG_REPORTING_SERVICES } from '@src/config/env'

import { createStorefrontSdkClient } from './storefront-sdk-client'

export function createReportingSdkClient() {
  return createStorefrontSdkClient(CONFIG_REPORTING_SERVICES, {
    retry: 1,
    authInterceptor: true,
  })
}

let reportingSdkClient: ReturnType<typeof createReportingSdkClient> | null = null

export function getReportingSdkClient(): ReturnType<typeof createReportingSdkClient> {
  if (!reportingSdkClient) {
    reportingSdkClient = createReportingSdkClient()
  }
  return reportingSdkClient
}
